import { SAButton } from '@saux/design-system-react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import success_png from '../../icons/Success.png';
import error_png from '../../icons/Error.png';
import snackbarOpen from '../../store/action-creators/snackbarActionCreators';
import { getAllAdjusters } from '../../store/actions/adjusterActions';
import { bulkAddAdjuster, bulkCoverAdjuster, bulkTransferAdjuster } from '../../store/actions/conversationActions';
import { CONVERSATION_CONTROL_TABS, COPY, COPY_ALL, COVER, COVER_ALL, SEARCH, SNACKBAR, TEXTING_ACCESS, TRANSFER, TRANSFER_ALL } from '../../utils/constants';
import { simpleGTMDataLayer } from '../../utils/utilities';
import APIResponsePage from '../dashboardAPIResponsePage/DashboardAPIResponsePage';
import { updateBatchType, updateFromAdjuster, updateToAdjuster } from '../../store/action-creators/adjusterActionCreator';
import { AutoCompleteTexting } from '../adjusterSearch/AutoCompleteTexting';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import { TextField } from '@material-ui/core';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { StyledEngineProvider } from '@mui/material/styles';
import { SADatePicker } from '../DatePicker/DatePicker';
import { Icon } from '../Icon/Icon';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { selectedConversation } from '../../store/action-creators/conversationActionCreator';
import { isNull } from 'lodash';

const AdjusterComponent = styled.div`
    position:relative;
`;
export default function Cover(props: any) {
    const [isFocussed, setFocussed] = useState(false);
    const [isAPISuccess, setAPISuccess] = useState(false);
    const [selectedAdjuster, setSelectedAdjuster] = useState<any>(null);
    const [apiResponse, setAPIResponse] = useState<any>({});
    const [count, setCount] = useState(0);
    const user = useSelector((state: any) => state.user);
    const [adjusters, setAdjusters] = useState([]);
    const loader = useSelector((state: any) => state.loader.dashboardLoader)
    const dispatch = useDispatch();
    const selectedButton = props.selectedButton;
    const isInitialAllConversations = (props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS && !selectedButton)
    const [dateView, setDateView] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [errors, setErrors] = useState<any>({ startDate: false, endDate: false });
    const [errorStartDate, setErrorStartDate] = useState<boolean>(false);
    const [errorEndDate, setErrorEndDate] = useState<boolean>(false);
    const [confirmCover, setConfirmCover] = useState<boolean>(false);

    const startDateChange = (date: Date, value?: string | null | undefined) => {
        // let formatDate = getFormattedDate(date);
        setStartDate(date);
        setErrorStartDate(false);

    };

    const endDateChange = (date: Date, value?: string | null | undefined) => {
        // let formatDate = getFormattedDate(date);
        setEndDate(date);
        setErrorEndDate(false);

    };

    const getFormattedDate = (date: Date | null) => {
        if (!isNull(date)) {
            var year: any = date.getFullYear();

            var month = (1 + date.getMonth()).toString();
            month = month.length > 1 ? month : '0' + month;

            var day = date.getDate().toString();
            day = day.length > 1 ? day : '0' + day;

            return year + '-' + month + '-' + day;
        }
    }

    useEffect(() => {
        console.log('error state', errors);
    }, [errors])

    const dateFormatter = (coverDate: any) => {
        if (!isNull(coverDate)) {
            var year: any = coverDate.getFullYear();

            var month = (1 + coverDate.getMonth()).toString();
            month = month.length > 1 ? month : '0' + month;

            var day = coverDate.getDate().toString();
            day = day.length > 1 ? day : '0' + day;

            return month + '/' + day + '/' + year;
        }
      //  return (coverDate.getMonth() > 8) ? (coverDate.getMonth() + 1) : ('0' + (coverDate.getMonth() + 1)) + '/' + ((coverDate.getDate() > 9) ? coverDate.getDate() : ('0' + coverDate.getDate())) + '/' + coverDate.getFullYear();
    }

    const handlDateNext = () => {
        if (!startDate || !endDate) {
            if (!startDate && !endDate) {
                console.log('inside first condn')
                setErrorStartDate(true);
                setErrorEndDate(true);

            }
            else if (!startDate) {
                setErrorStartDate(true);
            }
            else {
                setErrorEndDate(true);
            }

        }
        else if (startDate > endDate) {
            dispatch(snackbarOpen({ open: true, message: 'Start Date can not be after the End Date', type: SNACKBAR.ERROR }))
        }
        else {
            console.log('good to go')
            setDateView(false);
            setConfirmCover(true);
        }

    };

    useEffect(() => {
        setCount(props.count);
    }, [])

    const handleActionDate = () => {
        setDateView(true)
    }

    const handleAction = () => {
        setConfirmCover(false);
        props?.setConversationsEmpty();
        dispatch(updateToAdjuster(selectedAdjuster));
        dispatch(updateBatchType(COVER));
        //dispatch(updateBatchType((selectedButton === TRANSFER || selectedButton === TRANSFER_ALL) ?TRANSFER:(selectedButton === COVER) ? COVER : COPY))
        if (props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS) {
            dispatch(updateFromAdjuster(props.fromAdjuster));
        }
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Confirm-${selectedButton}-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Confirm ${selectedButton} the conversations`,
            event_value: `${user.fullName} was requesting for ${selectedButton} ${selectedAdjuster.adjusterName} conversations. `
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Confirm-${selectedButton}-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Confirm ${selectedButton} the conversations`,
            event_value: `${user.fullName} was requesting for ${selectedButton} ${selectedAdjuster.adjusterName} conversations. `
        });

        //Conversations count Snowplow tag
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Conversations-Count`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Select ${props.count} conversations`,
            event_value: `${user.fullName} selected ${props.count} conversations to Cover.`
          });
          simpleGTMDataLayer({
            csrId: user.userName,
            event: `Conversations-Count-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Selected ${props.count} conversations`,
            event_value: `${user.fullName} selected ${props.count} conversations to Cover.`
          });
        
        //API call
        const conversations = Object.values(props.selectedConversations)
            .map((con: any) => {
                return con.conversationId;

            });
        const currentAdjuster = props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS ? props.fromAdjuster.adjusterEmailId:user.email;
        const createCoverScheduleInput: any = {
            conversationIds: selectedButton === COVER_ALL ? [] : conversations,
            currentAdjusterId: currentAdjuster,
          //  currentAdjusterName: user.fullName,
            newAdjusterId: selectedAdjuster.adjusterEmailId,
            newAdjusterName: selectedAdjuster.adjusterName,
            startDate: getFormattedDate(startDate),
            endDate: getFormattedDate(endDate)
        }
        if (props.selectedButton === COVER_ALL) {
            createCoverScheduleInput["actionFlag"] = "all";
        }
       
        if (props.selectedButton === COVER || props.selectedButton === COVER_ALL && props.selectedType === CONVERSATION_CONTROL_TABS.MYCONVERSATIONS) {
            dispatch(bulkCoverAdjuster(createCoverScheduleInput, (res: any) => {
                setAPIResponse(res);
                setAPISuccess(true);
            }, (error: any) => {
                setAdjusters([]);
            }))
        }
        else {
            if (props.selectedButton === COVER_ALL && props.selectedType === CONVERSATION_CONTROL_TABS.ALLCONVERSATIONS) {
                createCoverScheduleInput["actionFlag"] = "all-" + user.email;
                createCoverScheduleInput["currentAdjusterId"] = props.fromAdjuster.adjusterEmailId;
            }
            dispatch(bulkCoverAdjuster(createCoverScheduleInput, (res: any) => {
                setAPIResponse(res);
                setAPISuccess(true);
            }, (error: any) => {
                setAdjusters([])
            }))
        }
    }

    const handleSearchConversations = () => {
        props.updateAdjuster(selectedAdjuster);
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Search-Adjuster-Conversations-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Tab click in conversation control page`,
            event_value: `${user.fullName} was requesting for ${selectedAdjuster.adjusterName} conversations for copying to other adjuster. `
        });

        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Search-Adjuster-Conversations-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Tab click in conversation control page`,
            event_value: `${user.fullName} was requesting for ${selectedAdjuster.adjusterName} conversations for copying to other adjsuter. `
        });
    }

    const getSuccessText = () => {
        return (<div>
            <div>
                You have successfully started the process for <span style={{ fontWeight: 'bold' }}> {selectedAdjuster.adjusterName} </span> to <span style={{ fontWeight: 'bold' }}> {selectedButton} </span>
            </div>
            <div>
                <span style={{ fontWeight: 'bold' }}> {count}  Coversations</span> for the following dates:
            </div>
            <div style={{ marginTop: "30px", fontWeight: "bold", fontSize: "18px" }}>
                {dateFormatter(startDate)} - {dateFormatter(endDate)}
            </div>
        </div>
        )
    }

    const getSubText = () => {
        let type = selectedButton === TRANSFER ? "Transferred" : "copied"
        return `[${apiResponse.failed}] Conversations were not ${type} from [${props.fromAdjuster.adjusterName}] to [${selectedAdjuster.adjusterName}] because they are already part of the conversation`;
    }

    const handleSelect = (index: any) => {
        setFocussed(false);
        if(props.fromAdjuster !==undefined){
            let filterAdjuster = adjusters.filter((adj:any)=>{
                return adj.adjusterEmailId !== props.fromAdjuster.adjusterEmailId
            });
            setSelectedAdjuster(filterAdjuster[index]);
        }
        else{
            let adjuster = adjusters.filter((adj:any)=>{
                return adj.adjusterEmailId !== user.email
            });
            setSelectedAdjuster(adjuster[index]);
        }
      
    }

    const handleChange = (value: any) => {
        getAllAdjusters({ query: value, adjusterRoles: [TEXTING_ACCESS] }).then((res: any) => {
            let adjustersList = res.data && res.data && res.data.searchAdjuster;
            let updatedList = adjustersList
                //.filter((adj: any) => adj.role_name === TEXTING_ACCESS)
                .map((user: any) => {
                    return {
                        adjusterName: user.adjuster_name?.replace(/- /g, ""),
                        adjusterEmailId: user.contact_email?.toLowerCase()
                    }
                })
            setAdjusters(updatedList);
        }).catch(error => {
            console.log(error);
            dispatch(snackbarOpen({ open: true, message: error.message, type: SNACKBAR.ERROR }))
        })
    }
    const getAutoCompleteLabel = () => {
        const label = isInitialAllConversations
            ? "Select an Adjuster" : "Select an Adjuster to " + selectedButton;
        return label;
    }

    const isFutureDate = (date: Date) => {
        const today = new Date();

        today.setHours(23, 59, 59, 998);

        return date > today;
    }

    const getAdjusterNames = () => {
        return adjusters
            .filter((adjuster: any) => {
                if (isInitialAllConversations || props.selectedType === CONVERSATION_CONTROL_TABS.MYCONVERSATIONS) {
                    return adjuster?.adjusterEmailId !== user.email;
                } else {
                    return props.fromAdjuster?.adjusterEmailId !== adjuster?.adjusterEmailId;
                }
            })
            .map((adjuster: any) => {
                return adjuster.adjusterName;
            })
    }

    return (
        loader.isLoading ?
            <div className="loader" />
            :
            <AdjusterComponent data-testid="adjuster-search">
                {!isAPISuccess ?
                    confirmCover ?
                        <>
                            <div data-testid="cover-confirmdate" style={{ marginTop: "35px", fontSize: "16px" }}>
                                <div >
                                    You have chosen <span style={{ fontWeight: "bold" }}>{selectedAdjuster.adjusterName} </span>to <span style={{ fontWeight: "bold" }}>COVER {props.count}</span>
                                </div>
                                <div>
                                    Conversations for the following dates:
                                    <div style={{ marginTop: "30px", fontWeight: "bold", fontSize: "18px" }}>
                                        {dateFormatter(startDate)} - {dateFormatter(endDate)}
                                    </div>
                                </div>
                            </div>

                            <div style={{ display: 'flex', position: "fixed", left: "80%", top: "80%" }}>
                                <SAButton style={{ color: "black" }} label="BACK" variant="link-small" onClick={() => { setConfirmCover(false); setDateView(true) }} />
                                <SAButton style={{ color: "white", backgroundColor: "#65A100", fontSize: 16 }} label="COMPLETE" variant="small" disabled={selectedAdjuster ? false : true} onClick={handleAction} />
                            </div>

                        </>

                        :
                        <div>
                            <div style={{ fontWeight: "bold", marginBottom: 20 }}>{isInitialAllConversations ? "Search for Adjuster Conversations" : dateView ? `Select the DATES for ADJUSTER NAME to COVER` : `Select the adjuster to COVER for ${props.count} conversations:`}</div>
                            {
                                dateView ?
                                    <>
                                        <div style={{ width: "35%" }}>
                                            <SADatePicker
                                                id={'from date'}
                                                data-testid="start-date"
                                                label="Start Date"
                                                name={'Start Date'}
                                                value={startDate}
                                                keyboardIcon={<Icon name="calendar" />}
                                                onChange={startDateChange}
                                                onBlur={() => startDate ? setErrors({ ...errors, startDate: false }) : setErrors({ ...errors, startDate: true })}
                                                error={errorStartDate}
                                                helperText={errorStartDate ? 'Please enter start date' : undefined}
                                                shouldDisableDate={(day: MaterialUiPickersDate) =>
                                                    (day &&
                                                        (day.getTime() <= Date.now() - 86400000)) ||
                                                    false
                                                }
                                            />
                                        </div>
                                        <div style={{ height: "50px" }}></div>
                                        <div style={{ width: "35%" }}>
                                            <SADatePicker
                                                id={'end date'}
                                                data-testid="end-date"
                                                label="End Date"
                                                name={'End Date'}
                                                value={endDate}
                                                keyboardIcon={<Icon name="calendar" />}
                                                onChange={endDateChange}
                                                onBlur={() => endDate ? setErrors({ ...errors, endDate: false }) : setErrors({ ...errors, endDate: true })}
                                                error={errorEndDate}
                                                helperText={errorEndDate ? 'Please enter end date' : undefined}
                                                shouldDisableDate={(day: MaterialUiPickersDate) =>
                                                    (day &&
                                                        (day.getTime() <= Date.now() - 86400000)) ||
                                                    false
                                                }
                                            />
                                        </div>

                                    </>

                                    :

                                    <AutoCompleteTexting
                                        id="adjusters"
                                        data-testid="select-adjuster"
                                        label={getAutoCompleteLabel()}
                                        fullWidth={true}
                                        options={getAdjusterNames()}
                                        onFocus={(e: any) => setFocussed(true)}
                                        onBlur={(e: any) => setFocussed(false)}
                                        onChange={(e: any) => handleChange(e.currentTarget.value)}
                                        onSelect={(index: number) => handleSelect(index)}
                                    />

                            }
                            <div style={{ display: "flex", float: "right", marginTop: isFocussed ? 250 : 25 }}>
                                {isInitialAllConversations ?
                                    <>
                                        <SAButton style={{ color: "white", backgroundColor: "#65A100", fontSize: 16 }} label={SEARCH} variant="small" disabled={selectedAdjuster ? false : true} onClick={handleSearchConversations} />
                                    </> :
                                    dateView ?
                                        <div style={{ display: 'flex', position: "fixed", left: "80%", top: "80%" }}>
                                            <SAButton style={{ color: "black" }} label="BACK" variant="link-medium" onClick={() => { setDateView(false); setStartDate(null); setEndDate(null) }} />
                                            <SAButton style={{ color: "white", backgroundColor: "#65A100", fontSize: 16 }} label="NEXT" variant="medium" disabled={selectedAdjuster ? false : true} onClick={handlDateNext} />
                                        </div>
                                        :

                                        <>
                                            <SAButton style={{ color: "black" }} label="BACK" variant="link-small" onClick={props.handleCancel} />
                                            <SAButton style={{ color: "white", backgroundColor: "#65A100", fontSize: 16 }} label="NEXT" variant="small" disabled={selectedAdjuster ? false : true} onClick={handleActionDate} />
                                        </>
                                }
                            </div>
                        </div> :
                    <APIResponsePage
                        text={getSuccessText()}
                        count={count}
                        selectedType={props.selectedType}
                        handleViewConversations={props.handleViewConversations}
                        handleNewSearch={props.handleNewSearch}
                        selectedAction ={props.selectedButton}
                    />}
            </AdjusterComponent>
    )
}
